import CountdownTimer from "@/components/countDown";
import useLoginByOtpCode from "@/services/auth/hooks/useLoginByOtpCode";
import useSendPasswordOtp from "@/services/auth/hooks/useSendPasswordOtp";
import useSignUp from "@/services/auth/hooks/useSignUp";
import { Button, Stack, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

type Props = {
  resendType: "singUp" | "login" | "forgetPassword";
};

const OtpSender: React.FC<Props> = ({ resendType }) => {
  const [isCountdownFinished, setIsCountdownFinished] = useState(false);
  const [startCountdown, setStartCountdown] = useState(false);
  const [resetCountdown, setResetCountdown] = useState(false);

  const { mutate, isSuccess, isLoading } = useLoginByOtpCode();

  const {
    mutate: forgetPasswordMutate,
    isLoading: isForgetPasswordLoading,
    isSuccess: isForgetPasswordSuccess,
  } = useSendPasswordOtp();

  const {
    mutate: signUpMutate,
    isSuccess: isSignUpSuccess,
    isLoading: isLoadingSuccess,
  } = useSignUp();

  const location = useLocation();
  const { mobileNumber, phoneNumber } = location.state;

  const handleCountdownFinish = () => {
    setIsCountdownFinished(true);
  };

  useEffect(() => {
    handleStart();
  }, []);

  const handleStart = () => {
    setStartCountdown(true);
    setResetCountdown(false);
    setIsCountdownFinished(false);
  };

  const handleResendOtp = () => {
    if (resendType === "login") {
      mutate({
        username: mobileNumber || phoneNumber,
      });
    }
    if (resendType === "singUp") {
      signUpMutate({
        mobileNumber: mobileNumber || phoneNumber,
      });
    }
    if (resendType === "forgetPassword") {
      forgetPasswordMutate({
        username: mobileNumber || phoneNumber,
      });
    }
  };

  useEffect(() => {
    if (isSuccess || isSignUpSuccess || isForgetPasswordSuccess) {
      setResetCountdown(true);
      setIsCountdownFinished(false);
      setStartCountdown(true);
    }
  }, [isSuccess, isSignUpSuccess, isForgetPasswordSuccess]);

  return (
    <Stack justify="center" align="center" mt="md">
      {isCountdownFinished ? (
        <Button
          loading={isLoading || isLoadingSuccess || isForgetPasswordLoading}
          size="compact-xs"
          onClick={handleResendOtp}
          w={180}
        >
          <Text size="xs">ارسال مجدد کد فعال سازی</Text>
        </Button>
      ) : (
        <CountdownTimer
          initialSeconds={120}
          onFinish={handleCountdownFinish}
          startCountdown={startCountdown}
          resetCountdown={resetCountdown}
        />
      )}
    </Stack>
  );
};

export default OtpSender;
